import exifr from "exifr";
import type { AppointmentWorkflowMetaData } from "@/models/appointment-task.model";

export async function extractPhotoMetadata(
  file: File,
  options?: { isCapture?: boolean }
): Promise<AppointmentWorkflowMetaData> {
  const result: AppointmentWorkflowMetaData = {};

  const isCapture = options?.isCapture ?? false;

  if (!isCapture) {
    try {
      const exif = await exifr.parse(file, {
        pick: ["DateTimeOriginal", "CreateDate", "GPSLatitude", "GPSLongitude"],
      });
      if (exif?.DateTimeOriginal) {
        const d = exif.DateTimeOriginal instanceof Date ? exif.DateTimeOriginal : new Date(exif.DateTimeOriginal);
        if (!isNaN(d.getTime())) result.photo_captured_at = d.toISOString();
      }
      if (result.photo_captured_at == null && exif?.CreateDate) {
        const d = exif.CreateDate instanceof Date ? exif.CreateDate : new Date(exif.CreateDate);
        if (!isNaN(d.getTime())) result.photo_captured_at = d.toISOString();
      }
      if (typeof exif?.latitude === "number" && !isNaN(exif.latitude)) result.lat = exif.latitude;
      if (typeof exif?.longitude === "number" && !isNaN(exif.longitude)) result.lng = exif.longitude;
    } catch {
      // EXIF parse failed; fall through to capture-style fallbacks
    }
  }

  if (result.photo_captured_at == null) {
    result.photo_captured_at = new Date().toISOString();
  }

  if (result.lat == null && result.lng == null && typeof navigator !== "undefined" && navigator.geolocation) {
    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000, maximumAge: 60000 });
      });
      if (position?.coords?.latitude != null && !isNaN(position.coords.latitude)) {
        result.lat = position.coords.latitude;
      }
      if (position?.coords?.longitude != null && !isNaN(position.coords.longitude)) {
        result.lng = position.coords.longitude;
      }
    } catch {
      // Geolocation denied or failed; leave lat/lng unset
    }
  }

  return result;
}
